import { useState, useEffect } from 'react';
import { ForecastModel, BaseForecastModelWithAvailability } from '@app/common/static-data/models';

interface UseForecastModelsProps {
  availableModels: BaseForecastModelWithAvailability[];
  initialModels?: ForecastModel[];
}

export function useForecastModels({ availableModels, initialModels = [] }: UseForecastModelsProps) {
  const [selectedModels, setSelectedModels] = useState<ForecastModel[]>(initialModels);

  // Update selected models when initialModels changes (from cache)
  useEffect(() => {
    if (initialModels.length > 0) {
      setSelectedModels(initialModels);
    }
  }, [initialModels]);

  // Filter selected models based on availability, but only when we have available models
  useEffect(() => {
    // Don't filter if availableModels is empty (still loading)
    if (availableModels.length === 0) return;

    const availableModelIds = new Set(availableModels.filter((m) => m.available).map((m) => m.id));
    const filteredSelectedModels = selectedModels.filter((modelId) =>
      availableModelIds.has(modelId),
    );

    if (filteredSelectedModels.length !== selectedModels.length) {
      setSelectedModels(filteredSelectedModels);
    }
  }, [availableModels, selectedModels]);

  return {
    selectedModels,
    setSelectedModels,
  };
}
